export const COUNTRY = {
  af: { text: 'Afghanistan', flag: 'af', value: 'af', code: '+93', format: '###############' },
  ax: {
    text: 'Aland Islands',
    flag: 'ax',
    value: 'ax',
    code: '+35818',
    format: '###############',
  },
  al: { text: 'Albania', flag: 'al', value: 'al', code: '+355', format: '###############' },
  dz: { text: 'Algeria', flag: 'dz', value: 'dz', code: '+213', format: '###############' },
  as: {
    text: 'American Samoa',
    flag: 'as',
    value: 'as',
    code: '+1684',
    format: '###############',
  },
  ad: { text: 'Andorra', flag: 'ad', value: 'ad', code: '+376', format: '###############' },
  ao: { text: 'Angola', flag: 'ao', value: 'ao', code: '+244', format: '###############' },
  ai: { text: 'Anguilla', flag: 'ai', value: 'ai', code: '+1264', format: '###############' },
  ag: { text: 'Antigua', flag: 'ag', value: 'ag', code: '+1268', format: '###############' },
  ar: { text: 'Argentina', flag: 'ar', value: 'ar', code: '+54', format: '###############' },
  am: { text: 'Armenia', flag: 'am', value: 'am', code: '+374', format: '###############' },
  aw: { text: 'Aruba', flag: 'aw', value: 'aw', code: '+297', format: '###############' },
  au: { text: 'Australia', flag: 'au', value: 'au', code: '+61', format: '###############' },
  at: { text: 'Austria', flag: 'at', value: 'at', code: '+43', format: '###############' },
  az: { text: 'Azerbaijan', flag: 'az', value: 'az', code: '+994', format: '###############' },
  bs: { text: 'Bahamas', flag: 'bs', value: 'bs', code: '+1242', format: '###############' },
  bh: { text: 'Bahrain', flag: 'bh', value: 'bh', code: '+973', format: '###############' },
  bd: { text: 'Bangladesh', flag: 'bd', value: 'bd', code: '+880', format: '###############' },
  bb: { text: 'Barbados', flag: 'bb', value: 'bb', code: '+1246', format: '###############' },
  by: { text: 'Belarus', flag: 'by', value: 'by', code: '+375', format: '###############' },
  be: { text: 'Belgium', flag: 'be', value: 'be', code: '+32', format: '###############' },
  bz: { text: 'Belize', flag: 'bz', value: 'bz', code: '+501', format: '###############' },
  bj: { text: 'Benin', flag: 'bj', value: 'bj', code: '+229', format: '###############' },
  bm: { text: 'Bermuda', flag: 'bm', value: 'bm', code: '+1441', format: '###############' },
  bt: { text: 'Bhutan', flag: 'bt', value: 'bt', code: '+975', format: '###############' },
  bo: { text: 'Bolivia', flag: 'bo', value: 'bo', code: '+591', format: '###############' },
  ba: { text: 'Bosnia', flag: 'ba', value: 'ba', code: '+387', format: '###############' },
  bw: { text: 'Botswana', flag: 'bw', value: 'bw', code: '+267', format: '###############' },
  br: { text: 'Brazil', flag: 'br', value: 'br', code: '+55', format: '###############' },
  vg: {
    text: 'British Virgin Islands',
    flag: 'vg',
    value: 'vg',
    code: '+1284',
    format: '###############',
  },
  bn: { text: 'Brunei', flag: 'bn', value: 'bn', code: '+673', format: '###############' },
  bg: { text: 'Bulgaria', flag: 'bg', value: 'bg', code: '+359', format: '###############' },
  bf: { text: 'Burkina Faso', flag: 'bf', value: 'bf', code: '+226', format: '###############' },
  mm: { text: 'Burma', flag: 'mm', value: 'mm', code: '+95', format: '###############' },
  bi: { text: 'Burundi', flag: 'bi', value: 'bi', code: '+257', format: '###############' },
  tc: {
    text: 'Caicos Islands',
    flag: 'tc',
    value: 'tc',
    code: '+1649',
    format: '###############',
  },
  kh: { text: 'Cambodia', flag: 'kh', value: 'kh', code: '+855', format: '###############' },
  cm: { text: 'Cameroon', flag: 'cm', value: 'cm', code: '+237', format: '###############' },
  ca: { text: 'Canada', flag: 'ca', value: 'ca', code: '+1', format: '###############' },
  cv: { text: 'Cape Verde', flag: 'cv', value: 'cv', code: '+238', format: '###############' },
  ky: {
    text: 'Cayman Islands',
    flag: 'ky',
    value: 'ky',
    code: '+1345',
    format: '###############',
  },
  cf: {
    text: 'Central African Republic',
    flag: 'cf',
    value: 'cf',
    code: '+236',
    format: '###############',
  },
  td: { text: 'Chad', flag: 'td', value: 'td', code: '+235', format: '###############' },
  cl: { text: 'Chile', flag: 'cl', value: 'cl', code: '+56', format: '###############' },
  cn: { text: 'China', flag: 'cn', value: 'cn', code: '+86', format: '###############' },
  cx: { text: 'Christmas Island', flag: 'cx', value: 'cx', code: '+61', format: '###############' },
  cc: { text: 'Cocos Islands', flag: 'cc', value: 'cc', code: '+61', format: '###############' },
  co: { text: 'Colombia', flag: 'co', value: 'co', code: '+57', format: '###############' },
  km: { text: 'Comoros', flag: 'km', value: 'km', code: '+269', format: '###############' },
  cd: { text: 'Congo', flag: 'cd', value: 'cd', code: '+243', format: '###############' },
  cg: {
    text: 'Congo Brazzaville',
    flag: 'cg',
    value: 'cg',
    code: '+242',
    format: '###############',
  },
  ck: { text: 'Cook Islands', flag: 'ck', value: 'ck', code: '+682', format: '###############' },
  cr: { text: 'Costa Rica', flag: 'cr', value: 'cr', code: '+506', format: '###############' },
  ci: { text: 'Cote Divoire', flag: 'ci', value: 'ci', code: '+225', format: '###############' },
  hr: { text: 'Croatia', flag: 'hr', value: 'hr', code: '+385', format: '###############' },
  cu: { text: 'Cuba', flag: 'cu', value: 'cu', code: '+53', format: '###############' },
  cy: { text: 'Cyprus', flag: 'cy', value: 'cy', code: '+357', format: '###############' },
  cz: { text: 'Czech Republic', flag: 'cz', value: 'cz', code: '+420', format: '###############' },
  dk: { text: 'Denmark', flag: 'dk', value: 'dk', code: '+45', format: '###############' },
  dj: { text: 'Djibouti', flag: 'dj', value: 'dj', code: '+253', format: '###############' },
  dm: { text: 'Dominica', flag: 'dm', value: 'dm', code: '+1767', format: '###############' },
  do: {
    text: 'Dominican Republic',
    flag: 'do',
    value: 'do',
    code: '+809',
    format: '###############',
  },
  ec: { text: 'Ecuador', flag: 'ec', value: 'ec', code: '+593', format: '###############' },
  eg: { text: 'Egypt', flag: 'eg', value: 'eg', code: '+20', format: '###############' },
  sv: { text: 'El Salvador', flag: 'sv', value: 'sv', code: '+503', format: '###############' },
  gq: {
    text: 'Equatorial Guinea',
    flag: 'gq',
    value: 'gq',
    code: '+240',
    format: '###############',
  },
  er: { text: 'Eritrea', flag: 'er', value: 'er', code: '+291', format: '###############' },
  ee: { text: 'Estonia', flag: 'ee', value: 'ee', code: '+372', format: '###############' },
  et: { text: 'Ethiopia', flag: 'et', value: 'et', code: '+251', format: '###############' },
  fk: {
    text: 'Falkland Islands',
    flag: 'fk',
    value: 'fk',
    code: '+500',
    format: '###############',
  },
  fo: { text: 'Faroe Islands', flag: 'fo', value: 'fo', code: '+298', format: '###############' },
  fj: { text: 'Fiji', flag: 'fj', value: 'fj', code: '+679', format: '###############' },
  fi: { text: 'Finland', flag: 'fi', value: 'fi', code: '+358', format: '###############' },
  fr: { text: 'France', flag: 'fr', value: 'fr', code: '+33', format: '###############' },
  gf: { text: 'French Guiana', flag: 'gf', value: 'gf', code: '+594', format: '###############' },
  pf: {
    text: 'French Polynesia',
    flag: 'pf',
    value: 'pf',
    code: '+689',
    format: '###############',
  },
  ga: { text: 'Gabon', flag: 'ga', value: 'ga', code: '+241', format: '###############' },
  gm: { text: 'Gambia', flag: 'gm', value: 'gm', code: '+220', format: '###############' },
  ge: { text: 'Georgia', flag: 'ge', value: 'ge', code: '+995', format: '###############' },
  de: { text: 'Germany', flag: 'de', value: 'de', code: '+49', format: '###############' },
  gh: { text: 'Ghana', flag: 'gh', value: 'gh', code: '+233', format: '###############' },
  gi: { text: 'Gibraltar', flag: 'gi', value: 'gi', code: '+350', format: '###############' },
  gr: { text: 'Greece', flag: 'gr', value: 'gr', code: '+30', format: '###############' },
  gl: { text: 'Greenland', flag: 'gl', value: 'gl', code: '+299', format: '###############' },
  gd: { text: 'Grenada', flag: 'gd', value: 'gd', code: '+1473', format: '###############' },
  gp: { text: 'Guadeloupe', flag: 'gp', value: 'gp', code: '+590', format: '###############' },
  gu: { text: 'Guam', flag: 'gu', value: 'gu', code: '+1671', format: '###############' },
  gt: { text: 'Guatemala', flag: 'gt', value: 'gt', code: '+502', format: '###############' },
  gn: { text: 'Guinea', flag: 'gn', value: 'gn', code: '+224', format: '###############' },
  gw: { text: 'Guinea-Bissau', flag: 'gw', value: 'gw', code: '+245', format: '###############' },
  gy: { text: 'Guyana', flag: 'gy', value: 'gy', code: '+592', format: '###############' },
  ht: { text: 'Haiti', flag: 'ht', value: 'ht', code: '+509', format: '###############' },
  hm: { text: 'Heard Island', flag: 'hm', value: 'hm', code: '+ ', format: '###############' },
  hn: { text: 'Honduras', flag: 'hn', value: 'hn', code: '+504', format: '###############' },
  hk: { text: 'Hong Kong', flag: 'hk', value: 'hk', code: '+852', format: '###############' },
  hu: { text: 'Hungary', flag: 'hu', value: 'hu', code: '+36', format: '###############' },
  is: { text: 'Iceland', flag: 'is', value: 'is', code: '+354', format: '###############' },
  in: { text: 'India', flag: 'in', value: 'in', code: '+91', format: '###############' },
  io: {
    text: 'Indian Ocean Territory',
    flag: 'io',
    value: 'io',
    code: '+246',
    format: '###############',
  },
  id: { text: 'Indonesia', flag: 'id', value: 'id', code: '+62', format: '###############' },
  ir: { text: 'Iran', flag: 'ir', value: 'ir', code: '+98', format: '###############' },
  iq: { text: 'Iraq', flag: 'iq', value: 'iq', code: '+964', format: '###############' },
  ie: { text: 'Ireland', flag: 'ie', value: 'ie', code: '+353', format: '###############' },
  il: { text: 'Israel', flag: 'il', value: 'il', code: '+972', format: '###############' },
  it: { text: 'Italy', flag: 'it', value: 'it', code: '+39', format: '###############' },
  jm: { text: 'Jamaica', flag: 'jm', value: 'jm', code: '+1876', format: '###############' },
  sj: { text: 'Jan Mayen', flag: 'sj', value: 'sj', code: '+47', format: '###############' },
  jp: { text: 'Japan', flag: 'jp', value: 'jp', code: '+81', format: '###############' },
  jo: { text: 'Jordan', flag: 'jo', value: 'jo', code: '+962', format: '###############' },
  kz: { text: 'Kazakhstan', flag: 'kz', value: 'kz', code: '+7', format: '###############' },
  ke: { text: 'Kenya', flag: 'ke', value: 'ke', code: '+254', format: '###############' },
  ki: { text: 'Kiribati', flag: 'ki', value: 'ki', code: '+686', format: '###############' },
  kw: { text: 'Kuwait', flag: 'kw', value: 'kw', code: '+965', format: '###############' },
  kg: { text: 'Kyrgyzstan', flag: 'kg', value: 'kg', code: '+996', format: '###############' },
  la: { text: 'Laos', flag: 'la', value: 'la', code: '+856', format: '###############' },
  lv: { text: 'Latvia', flag: 'lv', value: 'lv', code: '+371', format: '###############' },
  lb: { text: 'Lebanon', flag: 'lb', value: 'lb', code: '+961', format: '###############' },
  ls: { text: 'Lesotho', flag: 'ls', value: 'ls', code: '+266', format: '###############' },
  lr: { text: 'Liberia', flag: 'lr', value: 'lr', code: '+231', format: '###############' },
  ly: { text: 'Libya', flag: 'ly', value: 'ly', code: '+218', format: '###############' },
  li: { text: 'Liechtenstein', flag: 'li', value: 'li', code: '+423', format: '###############' },
  lt: { text: 'Lithuania', flag: 'lt', value: 'lt', code: '+370', format: '###############' },
  lu: { text: 'Luxembourg', flag: 'lu', value: 'lu', code: '+352', format: '###############' },
  mo: { text: 'Macau', flag: 'mo', value: 'mo', code: '+853', format: '###############' },
  mk: { text: 'Macedonia', flag: 'mk', value: 'mk', code: '+389', format: '###############' },
  mg: { text: 'Madagascar', flag: 'mg', value: 'mg', code: '+261', format: '###############' },
  mw: { text: 'Malawi', flag: 'mw', value: 'mw', code: '+265', format: '###############' },
  my: { text: 'Malaysia', flag: 'my', value: 'my', code: '+60', format: '###############' },
  mv: { text: 'Maldives', flag: 'mv', value: 'mv', code: '+960', format: '###############' },
  ml: { text: 'Mali', flag: 'ml', value: 'ml', code: '+223', format: '###############' },
  mt: { text: 'Malta', flag: 'mt', value: 'mt', code: '+356', format: '###############' },
  mh: {
    text: 'Marshall Islands',
    flag: 'mh',
    value: 'mh',
    code: '+692',
    format: '###############',
  },
  mq: { text: 'Martinique', flag: 'mq', value: 'mq', code: '+596', format: '###############' },
  mr: { text: 'Mauritania', flag: 'mr', value: 'mr', code: '+222', format: '###############' },
  mu: { text: 'Mauritius', flag: 'mu', value: 'mu', code: '+230', format: '###############' },
  yt: { text: 'Mayotte', flag: 'yt', value: 'yt', code: '+262', format: '###############' },
  mx: { text: 'Mexico', flag: 'mx', value: 'mx', code: '+52', format: '###############' },
  fm: { text: 'Micronesia', flag: 'fm', value: 'fm', code: '+691', format: '###############' },
  md: { text: 'Moldova', flag: 'md', value: 'md', code: '+373', format: '###############' },
  mc: { text: 'Monaco', flag: 'mc', value: 'mc', code: '+377', format: '###############' },
  mn: { text: 'Mongolia', flag: 'mn', value: 'mn', code: '+976', format: '###############' },
  me: { text: 'Montenegro', flag: 'me', value: 'me', code: '+382', format: '###############' },
  ms: { text: 'Montserrat', flag: 'ms', value: 'ms', code: '+1664', format: '###############' },
  ma: { text: 'Morocco', flag: 'ma', value: 'ma', code: '+212', format: '###############' },
  mz: { text: 'Mozambique', flag: 'mz', value: 'mz', code: '+258', format: '###############' },
  na: { text: 'Namibia', flag: 'na', value: 'na', code: '+264', format: '###############' },
  nr: { text: 'Nauru', flag: 'nr', value: 'nr', code: '+674', format: '###############' },
  np: { text: 'Nepal', flag: 'np', value: 'np', code: '+977', format: '###############' },
  nl: { text: 'Netherlands', flag: 'nl', value: 'nl', code: '+31', format: '###############' },
  an: {
    text: 'Netherlandsantilles',
    flag: 'an',
    value: 'an',
    code: '+599',
    format: '###############',
  },
  nc: { text: 'New Caledonia', flag: 'nc', value: 'nc', code: '+687', format: '###############' },
  pg: { text: 'New Guinea', flag: 'pg', value: 'pg', code: '+675', format: '###############' },
  nz: { text: 'New Zealand', flag: 'nz', value: 'nz', code: '+64', format: '###############' },
  ni: { text: 'Nicaragua', flag: 'ni', value: 'ni', code: '+505', format: '###############' },
  ne: { text: 'Niger', flag: 'ne', value: 'ne', code: '+227', format: '###############' },
  ng: { text: 'Nigeria', flag: 'ng', value: 'ng', code: '+234', format: '###############' },
  nu: { text: 'Niue', flag: 'nu', value: 'nu', code: '+683', format: '###############' },
  nf: { text: 'Norfolk Island', flag: 'nf', value: 'nf', code: '+672', format: '###############' },
  kp: { text: 'North Korea', flag: 'kp', value: 'kp', code: '+850', format: '###############' },
  mp: {
    text: 'Northern Mariana Islands',
    flag: 'mp',
    value: 'mp',
    code: '+1670',
    format: '###############',
  },
  no: { text: 'Norway', flag: 'no', value: 'no', code: '+47', format: '###############' },
  om: { text: 'Oman', flag: 'om', value: 'om', code: '+968', format: '###############' },
  pk: { text: 'Pakistan', flag: 'pk', value: 'pk', code: '+92', format: '###############' },
  pw: { text: 'Palau', flag: 'pw', value: 'pw', code: '+680', format: '###############' },
  ps: { text: 'Palestine', flag: 'ps', value: 'ps', code: '+970', format: '###############' },
  pa: { text: 'Panama', flag: 'pa', value: 'pa', code: '+507', format: '###############' },
  py: { text: 'Paraguay', flag: 'py', value: 'py', code: '+595', format: '###############' },
  pe: { text: 'Peru', flag: 'pe', value: 'pe', code: '+51', format: '###############' },
  ph: { text: 'Philippines', flag: 'ph', value: 'ph', code: '+63', format: '###############' },
  pn: {
    text: 'Pitcairn Islands',
    flag: 'pn',
    value: 'pn',
    code: '+870',
    format: '###############',
  },
  pl: { text: 'Poland', flag: 'pl', value: 'pl', code: '+48', format: '###############' },
  pt: { text: 'Portugal', flag: 'pt', value: 'pt', code: '+351', format: '###############' },
  pr: {
    text: 'Puerto Rico',
    flag: 'pr',
    value: 'pr',
    code: '+1',
    format: '###############',
  },
  qa: { text: 'Qatar', flag: 'qa', value: 'qa', code: '+974', format: '###############' },
  re: { text: 'Reunion', flag: 're', value: 're', code: '+262', format: '###############' },
  ro: { text: 'Romania', flag: 'ro', value: 'ro', code: '+40', format: '###############' },
  ru: { text: 'Russia', flag: 'ru', value: 'ru', code: '+7', format: '###############' },
  rw: { text: 'Rwanda', flag: 'rw', value: 'rw', code: '+250', format: '###############' },
  sh: { text: 'Saint Helena', flag: 'sh', value: 'sh', code: '+290', format: '###############' },
  kn: {
    text: 'Saint Kitts and Nevis',
    flag: 'kn',
    value: 'kn',
    code: '+1869',
    format: '###############',
  },
  lc: { text: 'Saint Lucia', flag: 'lc', value: 'lc', code: '+1758', format: '###############' },
  pm: { text: 'Saint Pierre', flag: 'pm', value: 'pm', code: '+508', format: '###############' },
  vc: {
    text: 'Saint Vincent',
    flag: 'vc',
    value: 'vc',
    code: '+1784',
    format: '###############',
  },
  ws: { text: 'Samoa', flag: 'ws', value: 'ws', code: '+685', format: '###############' },
  sm: { text: 'San Marino', flag: 'sm', value: 'sm', code: '+378', format: '###############' },
  st: { text: 'Sao Tome', flag: 'st', value: 'st', code: '+239', format: '###############' },
  sa: { text: 'Saudi Arabia', flag: 'sa', value: 'sa', code: '+966', format: '###############' },
  'gb sct': {
    text: 'Scotland',
    flag: 'gb sct',
    value: 'gb sct',
    code: '+44',
    format: '###############',
  },
  sn: { text: 'Senegal', flag: 'sn', value: 'sn', code: '+221', format: '###############' },
  rs: { text: 'Serbia', flag: 'rs', value: 'rs', code: '+381', format: '###############' },
  sc: { text: 'Seychelles', flag: 'sc', value: 'sc', code: '+248', format: '###############' },
  sl: { text: 'Sierra Leone', flag: 'sl', value: 'sl', code: '+232', format: '###############' },
  sg: { text: 'Singapore', flag: 'sg', value: 'sg', code: '+65', format: '###############' },
  sk: { text: 'Slovakia', flag: 'sk', value: 'sk', code: '+421', format: '###############' },
  si: { text: 'Slovenia', flag: 'si', value: 'si', code: '+386', format: '###############' },
  sb: { text: 'Solomon Islands', flag: 'sb', value: 'sb', code: '+677', format: '###############' },
  so: { text: 'Somalia', flag: 'so', value: 'so', code: '+252', format: '###############' },
  za: { text: 'South Africa', flag: 'za', value: 'za', code: '+27', format: '###############' },
  kr: { text: 'South Korea', flag: 'kr', value: 'kr', code: '+82', format: '###############' },
  es: { text: 'Spain', flag: 'es', value: 'es', code: '+34', format: '###############' },
  lk: { text: 'Sri Lanka', flag: 'lk', value: 'lk', code: '+94', format: '###############' },
  sd: { text: 'Sudan', flag: 'sd', value: 'sd', code: '+249', format: '###############' },
  sr: { text: 'Suritext', flag: 'sr', value: 'sr', code: '+597', format: '###############' },
  sz: { text: 'Swaziland', flag: 'sz', value: 'sz', code: '+268', format: '###############' },
  se: { text: 'Sweden', flag: 'se', value: 'se', code: '+46', format: '###############' },
  ch: { text: 'Switzerland', flag: 'ch', value: 'ch', code: '+41', format: '###############' },
  sy: { text: 'Syria', flag: 'sy', value: 'sy', code: '+963', format: '###############' },
  tw: { text: 'Taiwan', flag: 'tw', value: 'tw', code: '+886', format: '###############' },
  tj: { text: 'Tajikistan', flag: 'tj', value: 'tj', code: '+992', format: '###############' },
  tz: { text: 'Tanzania', flag: 'tz', value: 'tz', code: '+255', format: '###############' },
  th: { text: 'Thailand', flag: 'th', value: 'th', code: '+66', format: '###############' },
  tl: { text: 'Timorleste', flag: 'tl', value: 'tl', code: '+670', format: '###############' },
  tg: { text: 'Togo', flag: 'tg', value: 'tg', code: '+228', format: '###############' },
  tk: { text: 'Tokelau', flag: 'tk', value: 'tk', code: '+690', format: '###############' },
  to: { text: 'Tonga', flag: 'to', value: 'to', code: '+676', format: '###############' },
  tt: { text: 'Trinidad', flag: 'tt', value: 'tt', code: '+1868', format: '###############' },
  tn: { text: 'Tunisia', flag: 'tn', value: 'tn', code: '+216', format: '###############' },
  tr: { text: 'Turkey', flag: 'tr', value: 'tr', code: '+90', format: '###############' },
  tm: { text: 'Turkmenistan', flag: 'tm', value: 'tm', code: '+993', format: '###############' },
  tv: { text: 'Tuvalu', flag: 'tv', value: 'tv', code: '+688', format: '###############' },
  ae: { text: 'UAE', flag: 'ae', value: 'ae', code: '+971', format: '###############' },
  ug: { text: 'Uganda', flag: 'ug', value: 'ug', code: '+256', format: '###############' },
  ua: { text: 'Ukraine', flag: 'ua', value: 'ua', code: '+380', format: '###############' },
  gb: { text: 'United Kingdom', flag: 'gb', value: 'gb', code: '+44', format: '###############' },
  us: { text: 'United States', flag: 'us', value: 'us', code: '+1', format: '(###) ###-####' },
  uy: { text: 'Uruguay', flag: 'uy', value: 'uy', code: '+598', format: '###############' },
  um: { text: 'US Minor Islands', flag: 'um', value: 'um', code: '+1', format: '###############' },
  vi: {
    text: 'US Virgin Islands',
    flag: 'vi',
    value: 'vi',
    code: '+1',
    format: '###############',
  },
  uz: { text: 'Uzbekistan', flag: 'uz', value: 'uz', code: '+998', format: '###############' },
  vu: { text: 'Vanuatu', flag: 'vu', value: 'vu', code: '+678', format: '###############' },
  va: { text: 'Vatican City', flag: 'va', value: 'va', code: '+379', format: '###############' },
  ve: { text: 'Venezuela', flag: 've', value: 've', code: '+58', format: '###############' },
  vn: { text: 'Vietnam', flag: 'vn', value: 'vn', code: '+84', format: '###############' },
  'gb wls': {
    text: 'Wales',
    flag: 'gb wls',
    value: 'gb wls',
    code: '+44',
    format: '###############',
  },
  wf: {
    text: 'Wallis and Futuna',
    flag: 'wf',
    value: 'wf',
    code: '+681',
    format: '###############',
  },
  eh: { text: 'Western Sahara', flag: 'eh', value: 'eh', code: '+212', format: '###############' },
  ye: { text: 'Yemen', flag: 'ye', value: 'ye', code: '+967', format: '###############' },
  zm: { text: 'Zambia', flag: 'zm', value: 'zm', code: '+260', format: '###############' },
  zw: { text: 'Zimbabwe', flag: 'zw', value: 'zw', code: '+263', format: '###############' },
};

